import React, { useState, useEffect } from "react";
import { Form, Button, Container, Row, Col, Card } from "react-bootstrap";
import { register } from "../actions/userActions";
import { useDispatch, useSelector } from "react-redux";
import Messages from "../components/Messages";
import Loader from "../components/Loader";
import { Link, useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faKey, faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import {
  StyledLabel,
  StyledInput,
  ModernButton,
} from "../components/DefaultImports";

const Title = styled.h3`
  text-transform: uppercase;
  color: #9fbbc1;
`;

const StyledCard = styled.div`
  width: 100%;
  max-width: 500px;
  padding: 15px;
  margin: 0 auto;
  box-sizing: border-box;

  @media (max-width: 576px) {
    padding: 10px;
  }
`;

const PasswordContainer = styled.div`
  position: relative;
`;

const StyledPasswordInput = styled(StyledInput)`
  padding-right: 40px;
`;

const PasswordToggleIcon = styled.div`
  position: absolute;
  top: 40%;
  right: 12px;
  transform: translateY(-50%);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    font-size: 18px;
    color: #ee754c;
  }
`;

function CreateAccountScreen({ onSwitchToLogin }) {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordsMatch, setPasswordsMatch] = useState(true);
  const [disableButton, setdisableButton] = useState(true);
  const [showPasswords, setShowPasswords] = useState(true);

  const dispatch = useDispatch();
  const userRegister = useSelector((state) => state.userRegister);
  const { isLoading, error } = userRegister;

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const location = useLocation();
  const navigate = useNavigate();
  const redirect = location.search ? location.search.split("=")[1] : "/";

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  const handleConfirmPasswordChange = (event) => {
    setConfirmPassword(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    // code to submit form goes here
    dispatch(register(name, email, password));
  };

  useEffect(() => {
    if (password !== confirmPassword || password == "") {
      setPasswordsMatch(false);
      setdisableButton(true);
    } else {
      setPasswordsMatch(true);
      setdisableButton(false);
    }
  }, [password, confirmPassword]);

  useEffect(() => {
    if (userInfo) {
      navigate("/");
    }
  }, [userInfo]);

  return (
    <Container
      fluid
      style={{
        padding: 0,
        margin: 0,
        width: "120%",
        maxWidth: "120%",
      }}
    >
      <StyledCard>
        <Form onSubmit={handleSubmit}>
          {error && <Messages variant="danger">{error}</Messages>}
          {isLoading && <Loader />}
          <Title>Criar nova conta</Title>
          <Form.Group controlId="formBasicEmail">
            <StyledInput
              type="text"
              placeholder="Nome de utilizador"
              value={name}
              required
              onChange={(e) => setName(e.target.value)}
            />

            <StyledInput
              type="email"
              placeholder="E-mail"
              value={email}
              required
              onChange={(e) => setEmail(e.target.value)}
            />
            <Form.Text className="text-muted"></Form.Text>
          </Form.Group>
          <Form.Group controlId="formBasicPassword">
            <PasswordContainer>
              <StyledPasswordInput
                required
                type={showPasswords ? "password" : "text"}
                placeholder="Criar uma palavra-passe"
                value={password}
                onChange={handlePasswordChange}
              />
              <PasswordToggleIcon
                onClick={() => setShowPasswords(!showPasswords)}
              >
                <FontAwesomeIcon icon={showPasswords ? faEyeSlash : faEye} />
              </PasswordToggleIcon>
            </PasswordContainer>
          </Form.Group>

          <Form.Group controlId="formBasicConfirmPassword">
            <PasswordContainer>
              <StyledPasswordInput
                required
                type={showPasswords ? "password" : "text"}
                placeholder="Confirmar a palavra-passe"
                value={confirmPassword}
                onChange={handleConfirmPasswordChange}
              />
              <PasswordToggleIcon
                onClick={() => setShowPasswords(!showPasswords)}
              >
                <FontAwesomeIcon icon={showPasswords ? faEyeSlash : faEye} />
              </PasswordToggleIcon>
            </PasswordContainer>
            {!passwordsMatch && (
              <Form.Text className="text-danger">
                As palavras-passe não coincidem.
              </Form.Text>
            )}
          </Form.Group>

          <ModernButton
            type="submit"
            disabled={disableButton}
            color="#de8c3a"
            fontSize="16px"
            style={{ width: "100%", marginTop: "20px" }}
          >
            Criar conta
          </ModernButton>
          <Card.Text className="mt-3 text-center">
            Já tem uma conta?
            <Button
              variant="link"
              style={{ color: "#f59878", textDecoration: "none" }}
              onClick={onSwitchToLogin}
            >
              Iniciar sessão
            </Button>
          </Card.Text>
        </Form>
      </StyledCard>
    </Container>
  );
}

export default CreateAccountScreen;
